angular.module 'zc.users'

.controller 'UserSidebarCtrl', ($scope, $state, Devise) ->
  $scope.Devise = Devise
  $scope.isActive = (menu) ->
    _.startsWith $state.current.name, menu



// WEBPACK FOOTER //
// ./src/zenclerk_modules/users/user_sidebar.controller.js.coffee